// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationNotes-cls1_rup","cls2":"TranslationNotes-cls2_eZk TranslationNotes-cls1_rup"};